let location_id = '';
$(document).on('click', '.show_times', async function () {
    $('#times_wrap').remove()
    $('#create_time_wrap').remove()
    $('#edit_time_wrap').remove()
    // close the calendar dialog element
    renderLoadingOverlay();

    location_name = $(this).attr('data-location-name');
    location_id = $(this).attr('data-location-id');
    let court_id = $(this).attr('data-court-id');
    let date = $(this).attr('data-date');
    renderTimes(location_id, court_id, date)
})

async function renderTimes(location_id, court_id, date) {
    times = await getTimes(location_id, court_id, date);
    console.log(times);
    show_times(location_id, court_id, times, date, location_name)
}

window.renderTimes = renderTimes;

function show_times(location_id, court_id, times, date, location_name) {

    console.log(location_name)
    console.log(times)
    console.log(user_id)
    let location_times = '';
    // Store booking_slots in a variable
    const bookingSlots = times.booking_slots;
    const slot_duration = times.slot_duration;

    // Function to search for a specific start_time
    const checkIsReservedByOtherUser = (slots, startTime) => {
        return slots.find(slot => slot.start_time === startTime && slot.reserved_at);
    };
    // Function to search for a specific start_time
    const checkIsBooked = (slots, startTime) => {
        return slots.find(slot => slot.start_time === startTime && slot.confirmed_at);
    };
    // Function to search for a specific start_time
    const checkIsBookedByCurrentUser = (slots, startTime) => {
        return slots.find(slot => slot.start_time === startTime && slot.user_id == user_id);
    };
    // Function to search for a specific start_time
    const checkIsConfirmed = (slots) => {
        return slots.find(slot => slot.confirmed_at != 'undefined' || slot.confirmed_at != null);
    };
    let no_advanced_booking_available = '';
    if (times.no_advanced_booking_available) {
        no_advanced_booking_available = `
            <div class="p-4 mb-4 text-sm rounded-lg bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-400 m-2" role="alert">
              <i class="fad fa-warning mr-2"></i> You can only book a max of ${times.court.booking_days_in_advance} days in advance for this court
            </div>
        `;
    } else if (times.length == 0) {
        location_times = `
            <div class="p-4 mb-4 text-sm rounded-lg bg-gray-900 text-blue-400 m-2" role="alert">
              <i class="fad fa-warning mr-2"></i> No times for this court
            </div>
        `;
    } else {
        for (time of times.time_intervals) {

            let end_time = moment('2025-01-05 ' + time).add(slot_duration, "minutes").format("HH:mm");

            let booked_slot = checkIsBooked(bookingSlots, `${time}:00`);

            if (booked_slot) {
                location_times += `<button class="time_confirmed" data-court-id="${court_id}" data-time="${time}" data-location-id="${location_id}" data-booking-slot-id="${booked_slot.id}" title="Confirmed booking.">${time} - ${end_time}</button>`;
            } else if (checkIsBookedByCurrentUser(bookingSlots, `${time}:00`, user_id)) {
                location_times += `<button class="time_reserved book_time" data-court-id="${court_id}" data-date="${date}" data-time="${time}" data-duration="${times.slot_duration}" data-location-id="${location_id}" title="Reserved by you">${time} - ${end_time}</button>`;
            } else if (checkIsReservedByOtherUser(bookingSlots, `${time}:00`)) {
                location_times += `<button class="time_reserved_by_other" data-court-id="${court_id}" data-date="${date}" data-time="${time}" data-duration="${times.slot_duration}" data-location-id="${location_id}" title="Reserved by other user">${time} - ${end_time}</button>`;
            } else {
                location_times += `<button class="time_available book_time" data-court-id="${court_id}" data-date="${date}" data-time="${time}" data-duration="${times.slot_duration}" data-location-id="${location_id}" title="Time available">${time} - ${end_time}</button>`;
            }
            // }
        }
    }

    let times_wrap = `
    <div id="times_wrap" class="fixed !z-[60] max-sm:top-1 inset-x-0 inset-y-0 top-0 sm:inset-0 overflow-autox bg-gray-900/80">
        <div id="times_scroller" class="flex items-start sm:items-centers pt-8 justify-center h-screen overflow-y-auto close_times transition-all duration-300">
            <div class="max-w-3xl mx-auto text-gray-400 w-[300px] mb-32">
                <div id="times_content" class="bg-gray-100 dark:bg-gray-800 p-4 xs:p-8 shadow rounded border border-gray-700 relative" style="display: none;">
                    <div class="text-md font-extrabold text-center dark:text-gray-100 mb-4">${location_name} - Court ${times.court.name} - ${moment(date).format("Do MMMM YYYY")}</div>
                    <div id="close_times" class="absolute top-1 right-1 cursor-pointer text-red-400 hover:bg-green-700/40 rounded-full w-8 h-8 flex justify-center items-center"><i class="fal fa-times text-xl"></i>
                    </div>
                    <div id="times" class="grid grid-cols-2 gap-1"></div>
                    <div id="no_advanced_booking_available" class="grid grid-cols-1 gap-1"></div>
                    <div id="time_controls" class="grid xs:gap-1 sm:gap-2"></div>
                </div>
            </div>
        </div>
    </div>
    `;

    $('body').prepend(times_wrap)
    if(times.no_advanced_booking_available) {
        $('#no_advanced_booking_available').append(no_advanced_booking_available);
    } else {
        $('#times').append(location_times);
    }

    $('#times_content').fadeIn(200);

    removeLoadingOverlay();

    $('#slide_in_times').click();
}

$(document).on('click', '#close_times, .close_times', function () {
    $('#times_wrap').fadeOut(200);
    setTimeout(function () {
        $('#times_wrap').remove()
        $(`.trigger-calendar[data-location-id="${location_id}"]`).click();
    }, 200)
})

$(document).on('click', '#times_content', function (event) {
    event.stopPropagation();
})

const getTimes = async (location_id, court_id, date) => {
    try {
        const response = await fetch(`/api/times`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            },
            body: JSON.stringify({
                json: true,
                location_id: location_id,
                court_id: court_id,
                date: date,
            })
        });
        return await response.json()
    } catch (error) {
        console.log(error)
    }
}
